const saveKey = (key, value) => window.localStorage.setItem(key, value);
const getKey = (key) => window.localStorage.getItem(key);
const deleteKey = (key) => window.localStorage.removeItem(key);
export const keyProxy = (key) => ({
    get: () => getKey(key),
    set: (value) => saveKey(key, value),
    delete: () => deleteKey(key),
});
export const keyProxyWithTransformers = (key, serializer, deserializer) => ({
    get: () => deserializer(getKey(key)),
    set: (value) => saveKey(key, serializer(value)),
    delete: () => deleteKey(key),
});
//# sourceMappingURL=localStorage.js.map